<template>
 <h1 class="component-heading">Speed dial</h1>
  <p class="component-description">
A Speed Dial component is like a dialog with multiple floating action buttons. It can be used to make any primary actions like share, copy, print, etc. more accessible and make the user experience better.</p>  <divider :position="'horizontal'" :space="'20px'" />
  <h1 class="component-side-heading">Basic usage</h1>
  <p class="component-description">Set the direction of flow for your menu items to either vertical or horizontal using the <b>:direction</b> attribute</p>
  <div class="component-example">
    <div class="example-body">
<hlx-speeddial :speed-dial-data="speed_dial_data" :direction="'vertical'" @icon-chosen="iconChosen"/>
    </div>
    <div class="example-footer">
      <span id="basic-speed-dial-icon" class="icon" @click="showCode('basic-speed-dial')"><i class="icon-code-regular"></i></span>
    </div>
  </div>

  <div id="basic-speed-dial" class="source-code" style="display: none">
    <section class="example-source-wrapper">
      <div class="source">
        <CodeEditor
           :id="'editor'"  :display_language="false"
          :value="speed_dial_source"
          :read_only="true"
          :theme="editor_theme"
          :languages="[
            ['Javascript', 'Vue'],
            ['javascript', 'JS'],
            ['python', 'Python'],
          ]"
        />
      </div>
    </section>
  </div>
  <divider :position="'horizontal'" :space="'20px'" />
    <h2 class="component-side-heading">Attributes</h2>
    <hlx-table
    :border="['table', 'header', 'vertical', 'horizontal']"
    :bold-headers="false"
    :row-hover="false"
    theme="grey"
    :striped-rows="false"
    :column-count="6"
  >
    <template #thead>
      <hlx-table-head
        v-for="(i, index) in attributes"
        :key="index"
        :width="i.width"
        >{{ i.label }}</hlx-table-head
      >
    </template>
    <template #tbody>
      <tr v-for="(i, index) in table_data" id="" :key="index">
        <hlx-table-cell
          v-for="(j, col_index) in attributes"
          :key="col_index"
          :align="'left'"
        >
          {{ i[j.prop] }}
        </hlx-table-cell>
      </tr>
    </template>
  </hlx-table>
   <h2 class="component-side-heading">Events</h2>
   <hlx-table
    :border="['table', 'header', 'vertical', 'horizontal']"
    :bold-headers="false"
    :row-hover="false"
    theme="grey"
    :column-count="3"
    :striped-rows="false"
  >
    <template #thead>
      <hlx-table-head
        v-for="(i, index) in events"
        :key="index"
        :width="i.width"
        >{{ i.label }}</hlx-table-head
      >
    </template>
    <template #tbody>
      <tr v-for="(i, index) in event_data" id="" :key="index">
        <hlx-table-cell
          v-for="(j, col_index) in events"
          :key="col_index"
          :align="'left'"
        >
          {{ i[j.prop]  }}
        </hlx-table-cell>
      </tr>
    </template>
  </hlx-table>
  <divider :space="'20px'" class="mobile-nav-divider"/>
    <div class="mobile-next-page-nav">
      <span class="prev-btn" @click="prevNextPage('prev', 'tree')"
      ><i class="icon-angle-left-regular prev-icon"></i>Tree</span
    >
      <span class="nxt-btn" @click="prevNextPage('next', 'Colorpalette')"
        >Color palette <i class="icon-angle-right-regular"></i
      ></span>
    </div>
</template>


  
<script>
import hlxSpeeddial from '../components/SpeeddialComponent.vue'
import divider from "../components/DividerComponent.vue";
import CodeEditor from "simple-code-editor";
import hlxTable from "../components/table/HlxTable.vue";
import hlxTableHead from "../components/table/HlxTableHead.vue";
import hlxTableCell from "../components/table/HlxTableCell.vue";
export default {
components:{
    hlxSpeeddial,
    divider,
    hlxTableCell,
    hlxTableHead,
    hlxTable,
    CodeEditor,
},
data(){
  return{
    events: [
        {
          prop: "name",
          label: "Event name",
          width: 100,
          type: "string",
          format: "",
        },
        {
          prop: "description",
          label: "Description",
          width: 350,
          type: "string",
          format: "",
        },
        {
          prop: "parameter",
          label: "Parameter",
          width: 100,
          type: "string",
          format: "",
        },
      ],
      attributes: [
        {
          prop: "name",
          label: "Name",
          width: 100,
          type: "string",
          format: "",
        },
        {
          prop: "description",
          label: "Description",
          width: 250,
          type: "string",
          format: "",
        },
        {
          prop: "type",
          label: "Type",
          width: 50,
          type: "string",
          format: "",
        },
        {
          prop: "accepted_values",
          label: "Accepted values",
          width: 150,
          type: "string",
          format: "",
        },
        {
          prop: "default",
          label: "Default",
          width: 80,
          type: "string",
          format: "",
        },
        {
          prop: "mandatory",
          label: "Mandatory",
          width: 90,
          type: "string",
          format: "",
        },
      ],
          editor_theme: "light",

    speed_dial_data:
      {
        parent_icon:'icon-share-filled',
        children_icon:[
          'icon-facebook-f-filled',
          'icon-instagram-filled',
          'icon-twitter-filled'
        ]
      },
            speed_dial_source: `
<template>
  <hlx-speed-dial :speed_dial_data="this.speed_dial_data" @iconChosen="iconChosen" :direction="'vertical'"/>
</template>

<script>
export default{
    data(){
        return{
          speed_dial_data:
      {
        parent_icon:'icon-share',
        children_icon:[
          'icon-cart',
          'icon-bulb',
          'icon-rocket'
        ]
      },
          }
        }
      }
    }
    <\/script>`,
               table_data:[{
        name:'speed-dial-data',
        description:'Include your data for speed dial.',
        type:'Array of objects',
        accepted_values:'[{}]',
        default:'-',
        mandatory: true
      },
      {
        name:'direction',
        description:'Choose the direction of flow for your menu items',
        type:'String',
        accepted_values:'horizontal, vertical',
        default:'-',
        mandatory: true
      }],
                event_data:[
      {
        name:'icon-chosen',
        description:'Emits the icon chosen',
        parameter:'-'
      },
    ],
  }
},
    methods: {
      prevNextPage(nav, name) {
      if (nav === "prev") {
        sessionStorage.setItem("lastname", name);
        this.$router.push({ name: name });
      } else if (nav === "next") {
        sessionStorage.setItem("lastname", name);
        this.$router.push({ name: name });
      }
    },
    showCode(val) {
      document.getElementById(val + "-icon").classList.toggle("active-icon");
      if (document.getElementById(val).style.display === "none") {
        document.getElementById(val).style.display = "block";
      } else if (document.getElementById(val).style.display === "block") {
        document.getElementById(val).style.display = "none";
      }
    },
  },
}
</script>

<style>

</style>